// PRD 04 §1.2:
//   - PRO_MGMT:NO_PERMISSION → LNB still shows the menu (PRD 21 §4.5), entry is
//     blocked here with the 권한 없음 modal.
//   - READ → view tree + item details (no edit).
//   - WRITE / Root → full CRUD (controls gated in later slices).

import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { ProItemDesignView } from '@/features/pro-item-design/components/ProItemDesignView';
import {
  domainKey,
  nextTempId,
  useProItemDesignPageStore,
} from '@/features/pro-item-design/store/pro-item-design-page.store';
import { useWriteGuard } from '@/shared/hooks/useWriteGuard';

export function ProItemDesignPage() {
  const { t } = useTranslation('pro-item-design');
  // SHCT-171 — was a private in-page card. PRD 21 §7.2 specifies 권한 없음 as a 모달 with
  // "접근 권한이 없습니다.", so every gated page now blocks the same way through this hook.
  const canRead = useRequirePermission('PRO_MGMT', 'READ');
  const { canWrite, denyProps } = useWriteGuard('PRO_MGMT');
  const select = useProItemDesignPageStore((s) => s.select);
  const setExpanded = useProItemDesignPageStore((s) => s.setExpanded);
  const requestFocus = useProItemDesignPageStore((s) => s.requestFocus);
  const startDraft = useProItemDesignPageStore((s) => s.startDraft);

  if (!canRead) return null;

  // SHCT-388 / ADM.034 — Add no longer hits the backend; it parks a local draft
  // that is persisted (createDomain) only when the user clicks Save.
  const onAddArea = () => {
    const tempId = nextTempId();
    startDraft({ type: 'domain', tempId, name: t('defaults.newDomainName') });
    setExpanded(domainKey(tempId), true);
    select({ type: 'domain', id: tempId });
    requestFocus(tempId);
  };

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('title')}</h1>
        </div>
        <div className="content__actions">
          <button
            type="button"
            className="btn btn-default btn-primary"
            onClick={onAddArea}
            disabled={!canWrite}
            {...denyProps}
          >
            <Plus size={16} />
            {t('addAreaButton')}
          </button>
        </div>
      </div>
      <div className="content__body">
        <ProItemDesignView />
      </div>
    </>
  );
}
